import { useEffect } from 'react';

// Headless UI's Dialog closes on Escape. When closeOnEscape is false we swallow the key in the
// capture phase, before its listener runs.
export const usePreventEscapeClose = (isOpen: boolean, closeOnEscape: boolean): void => {
  useEffect(() => {
    if (closeOnEscape || !isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
    };
    document.addEventListener('keydown', handleKeyDown, true);
    return () => document.removeEventListener('keydown', handleKeyDown, true);
  }, [closeOnEscape, isOpen]);
};
